import { UpdatePostTitleStore, updatePosttitleUseCase } from "./updatePostTitleUseCase";


const clearPostTitleUseCase = (store: UpdatePostTitleStore) =>
    updatePosttitleUseCase(store, '');

export { clearPostTitleUseCase }